module.exports = __webpack_public_path__ + "img/moped_white.c1cff0bd.svg";